export default function initMaps() {
  var inputs = document.querySelectorAll("input[name='localisation']");
  if (!inputs.length) return;

  function trySetup() {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      setTimeout(trySetup, 100);
      return;
    }
    setup();
  }

  function setup() {
    var geocoder = new google.maps.Geocoder();

    inputs.forEach(function (input) {
      var ac = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'fr' },
        fields: ['formatted_address', 'name', 'geometry'],
      });

      function getCoordInputs() {
        var form = input.form;
        return {
          lat: form && form.querySelector("input[name='location-lat']"),
          lng: form && form.querySelector("input[name='location-lng']"),
        };
      }

      // Clear coords when user modifies the text after a selection.
      input.addEventListener('input', function () {
        var c = getCoordInputs();
        if (c.lat) c.lat.value = '';
        if (c.lng) c.lng.value = '';
      });

      // Autocomplete selection: fill coords directly.
      ac.addListener('place_changed', function () {
        var place = ac.getPlace();
        if (place.formatted_address) input.value = place.formatted_address;
        var c = getCoordInputs();
        if (place.geometry && place.geometry.location) {
          if (c.lat) c.lat.value = place.geometry.location.lat();
          if (c.lng) c.lng.value = place.geometry.location.lng();
        }
      });

      // Form submit: geocode client-side when localisation is filled but coords are missing.
      var form = input.form;
      if (!form) return;
      form.addEventListener('submit', function (e) {
        var c = getCoordInputs();
        if (!input.value || (c.lat && c.lat.value)) return;
        e.preventDefault();
        geocoder.geocode({ address: input.value, region: 'fr' }, function (results, status) {
          if (status === 'OK' && results[0]) {
            var loc = results[0].geometry.location;
            input.value = results[0].formatted_address;
            if (c.lat) c.lat.value = loc.lat();
            if (c.lng) c.lng.value = loc.lng();
          }
          form.submit();
        });
      });
    });
  }

  trySetup();
}